import { useEffect } from 'react';
import DashboardChat from '../../../CommonComponents/DashboardChat/DashboardChat';
import { useLocation } from 'react-router-dom';
import logAnalyticsEvent from '../../../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../../../services/AnalyticsManager/GGAnalyticsEvents';
import './MessagesPanel.scss';

export const MessagesPanel = () => {
    const state = useLocation().state;

    useEffect(() => {
        logAnalyticsEvent(GGAnalyticsEvents.MY_MESSAGES_PAGE_LOADED);
    }, []);

    return (
        <section className="dashboard-panel messages-panel">
            <div className="messages-panel-wrapper">
                <DashboardChat
                    {...(state?.channelId && { initialSelectedChannel: state.channelId })}
                    isDashboardContext={true}
                    // Don't pass onHeaderBackClick since we're inside the dashboard
                />
            </div>
    </section>
);
};
